// ──────────────────────────────────────────────────────────────
// Estados generales de la incidencia
// ──────────────────────────────────────────────────────────────
export const INCIDENT_STATUS = {
  abierta: 'Abierta',
  procesando: 'Procesando',
  cerrada: 'Cerrada',
};

export const INCIDENT_STATUS_COLOR = {
  abierta: 'danger',
  procesando: 'warning',
  cerrada: 'success',
};

// ──────────────────────────────────────────────────────────────
// Criticidad
// ──────────────────────────────────────────────────────────────
export const INCIDENT_SEVERITY = {
  critica: 'Crítica',
  alta: 'Alta',
  media: 'Media',
  baja: 'Baja',
};

export const INCIDENT_SEVERITY_COLOR = {
  critica: '#dc3545',
  alta: '#fd7e14',
  media: '#ffc107',
  baja: '#6c757d',
};

// ──────────────────────────────────────────────────────────────
// Responsable (legacy)
// ──────────────────────────────────────────────────────────────
export const INCIDENT_RESPONSIBLE = {
  vendedor: 'Vendedor',
  operador_logistico: 'Operador Logístico',
  transportista: 'Transportista',
  supervisor_logistico: 'Supervisor Logístico',
};

// ──────────────────────────────────────────────────────────────
// Tipos de incidencia agrupados por categoría
// ──────────────────────────────────────────────────────────────
export const INCIDENT_CATEGORIES = {
  entrega: 'Entrega',
  registro_sistema: 'Registro / Sistema',
  protocolo: 'Protocolo',
  paquete: 'Paquete',
  perdida: 'Pérdida',
  operacion: 'Operación',
  calidad: 'Calidad',
  general: 'General',
};

export const INCIDENT_TYPES_BY_CATEGORY = {
  entrega: {
    cliente_rechaza: 'Cliente rechaza pedido',
    cliente_desconoce: 'Cliente desconoce la entrega',
    direccion_equivocada: 'Entrega en dirección equivocada',
    entrega_vecino_sin_auth: 'Entrega al vecino sin autorización',
    entrega_fuera_horario: 'Entrega fuera de horario',
  },
  registro_sistema: {
    entregado_sin_evidencia: 'Entregado sin evidencia',
    evidencia_incorrecta: 'Evidencia incorrecta',
    evidencia_intercambiada: 'Evidencia intercambiada',
    entregado_sin_marcar: 'Entregado sin marcar',
    marcado_sin_entregar: 'Marcado sin entregar',
    entrega_mal_registrada: 'Entrega mal registrada en sistema',
    entrega_no_cerrada: 'Entrega no cerrada en plataforma',
  },
  protocolo: {
    incumplimiento_protocolo: 'Incumplimiento de protocolo',
    no_contacto_cliente: 'No contactó al cliente',
    no_reporto_problema: 'No reportó problema',
  },
  paquete: {
    paquete_deteriorado: 'Paquete deteriorado',
    paquete_roto: 'Paquete roto',
    paquete_incompleto: 'Paquete incompleto',
  },
  perdida: {
    paquete_extraviado: 'Paquete extraviado',
    paquete_robado: 'Paquete robado',
    paquete_no_encontrado: 'Paquete no encontrado en bodega',
  },
  operacion: {
    error_despacho: 'Error de despacho',
    error_ruteo: 'Error de ruteo',
    demora_excesiva: 'Demora excesiva en ruta',
  },
  calidad: {
    apelacion_calidad: 'Apelación de calidad',
  },
  general: {
    otro: 'Otro (requiere observación)',
  },
};

// Mapa plano tipo -> label (incluye legacy)
export const INCIDENT_TYPE_LABEL = {
  // Nuevos
  cliente_rechaza: 'Cliente rechaza pedido',
  cliente_desconoce: 'Cliente desconoce la entrega',
  direccion_equivocada: 'Entrega en dirección equivocada',
  entrega_vecino_sin_auth: 'Entrega al vecino sin autorización',
  entrega_fuera_horario: 'Entrega fuera de horario',
  entregado_sin_evidencia: 'Entregado sin evidencia',
  evidencia_incorrecta: 'Evidencia incorrecta',
  evidencia_intercambiada: 'Evidencia intercambiada',
  entregado_sin_marcar: 'Entregado sin marcar',
  marcado_sin_entregar: 'Marcado sin entregar',
  entrega_mal_registrada: 'Entrega mal registrada en sistema',
  entrega_no_cerrada: 'Entrega no cerrada en plataforma',
  incumplimiento_protocolo: 'Incumplimiento de protocolo',
  no_contacto_cliente: 'No contactó al cliente',
  no_reporto_problema: 'No reportó problema',
  paquete_deteriorado: 'Paquete deteriorado',
  paquete_roto: 'Paquete roto',
  paquete_incompleto: 'Paquete incompleto',
  paquete_extraviado: 'Paquete extraviado',
  paquete_robado: 'Paquete robado',
  paquete_no_encontrado: 'Paquete no encontrado en bodega',
  error_despacho: 'Error de despacho',
  error_ruteo: 'Error de ruteo',
  demora_excesiva: 'Demora excesiva en ruta',
  apelacion_calidad: 'Apelación de calidad',
  otro: 'Otro (requiere observación)',
  // Legacy
  paquete_danado: 'Paquete dañado',
  fuga_contenido: 'Fuga de contenido',
  direccion_incorrecta: 'Dirección incorrecta o no existe',
  robo_paquete: 'Robo del paquete',
};

// ──────────────────────────────────────────────────────────────
// Auto-asignación de criticidad por tipo
// ──────────────────────────────────────────────────────────────
export const AUTO_SEVERITY_BY_TYPE = {
  paquete_robado: 'critica',
  robo_paquete: 'critica',
  paquete_extraviado: 'critica',
  paquete_roto: 'alta',
  paquete_danado: 'alta',
  paquete_deteriorado: 'alta',
  paquete_incompleto: 'alta',
  direccion_equivocada: 'alta',
  fuga_contenido: 'alta',
  entregado_sin_evidencia: 'media',
  entregado_sin_marcar: 'media',
  marcado_sin_entregar: 'media',
  evidencia_incorrecta: 'media',
  evidencia_intercambiada: 'media',
  error_despacho: 'media',
  entrega_vecino_sin_auth: 'media',
  cliente_desconoce: 'media',
};

export function getAutoSeverity(incidentType) {
  return AUTO_SEVERITY_BY_TYPE[incidentType] || 'baja';
}

// ──────────────────────────────────────────────────────────────
// Auto-asignación de departamentos requeridos por tipo
// ──────────────────────────────────────────────────────────────
export const AUTO_DEPARTMENTS_BY_TYPE = {
  paquete_robado: ['sac', 'administration', 'supervision'],
  robo_paquete: ['sac', 'administration', 'supervision'],
  paquete_extraviado: ['sac', 'administration', 'supervision'],
  paquete_no_encontrado: ['sac', 'administration', 'supervision'],
  paquete_roto: ['sac', 'administration'],
  paquete_danado: ['sac', 'administration'],
  paquete_deteriorado: ['sac', 'administration'],
  paquete_incompleto: ['sac', 'administration'],
  fuga_contenido: ['sac', 'administration'],
  incumplimiento_protocolo: ['sac', 'supervision'],
  no_contacto_cliente: ['sac', 'supervision'],
  no_reporto_problema: ['sac', 'supervision'],
  apelacion_calidad: ['supervision'],
};

export function getRequiredDepartments(incidentType) {
  return AUTO_DEPARTMENTS_BY_TYPE[incidentType] || ['sac'];
}

// ──────────────────────────────────────────────────────────────
// Estado administrativo (pestaña Administración)
// ──────────────────────────────────────────────────────────────
export const ADMIN_PAYMENT_STATUS = {
  sin_respuesta: 'Sin respuesta',
  espera_facturacion: 'Espera de facturación',
  facturado: 'Facturado',
  pagado: 'Pagado',
  rechazado: 'Rechazado',
};

export const ADMIN_PAYMENT_STATUS_COLOR = {
  sin_respuesta: '#6c757d',
  espera_facturacion: '#ffc107',
  facturado: '#0d6efd',
  pagado: '#198754',
  rechazado: '#dc3545',
};

// ──────────────────────────────────────────────────────────────
// Labels de departamentos
// ──────────────────────────────────────────────────────────────
export const DEPARTMENT_LABELS = {
  sac: 'SAC',
  administration: 'Administración',
  supervision: 'Supervisión',
};
